import { MessageModalViewType } from '../types/view/MessageModalViewType';

// APIエラーレスポンス変更
export const changeUnexpectedErrorMessage = (errorMessage: string) => {
  let result = errorMessage;
  if (errorMessage === 'Bad Request') {
    //JWTトークン有効期限切れ対応
    result = 'マイアカウントトップに戻ってから再度お試しください。';
  }
  return result;
};

export const setNewOrderErrorMessage = (errorStatus: number): MessageModalViewType => {
  let errorMessage: MessageModalViewType;
  if (errorStatus === 403) {
    errorMessage = {
      title: '注文が確定できません',
      message: '支払方法を更新してください。',
    };
  } else if (errorStatus === 409 || errorStatus === 500) {
    errorMessage = {
      title: '注文を確定できません',
      message: 'しばらく経ってからもう一度お試しください。',
    };
  } else {
    errorMessage = {
      title: '注文を確定できません',
      message: '定期オトク便が確認できません。\nお問い合わせフォームよりご連絡ください。',
    };
  }
  return errorMessage;
};

export const truncateFullWidth = (str: string, maxLength: number): string => {
  let count = 0;
  let result = '';

  for (const char of str) {
    // 半角英数字・記号は 0.5、それ以外（全角）は 1
    const isHalfWidth = /^[\u0020-\u007E]$/.test(char);
    const charLength = isHalfWidth ? 0.5 : 1;

    if (count + charLength > maxLength) {
      result += '...';
      break;
    }

    result += char;
    count += charLength;
  }

  return result;
};
